module.exports = __webpack_public_path__ + "img/bg.edcb6c7a.svg";